import $ from 'jquery';
import dom from './dom';

const postHeader = () => {
  const $postShare = $('.c-post__lower--share');
  const $postNav = $('.c-post__nav');
  const $postNavShare = $('.c-post__nav--share');
  let transform = '0';

  if ($postShare && $postShare.length && $postNav && $postNav.length) {
    const globals = {
      offsetTop: $postShare.offset().top,
      windowScrollTop: dom.$win.scrollTop(),
      postHeight: dom.$doc.height() / 2,
    };

    const onResize = () => {
      globals.offsetTop = $postShare.offset().top;
      globals.windowScrollTop = dom.$win.scrollTop();
      globals.postHeight = dom.$doc.height() / 2;
    };
    onResize();
    dom.$win.on('resize', onResize);

    dom.$win.on('scroll touchmove', () => {
      globals.windowScrollTop = dom.$win.scrollTop();
      if (globals.windowScrollTop >= globals.postHeight) {
        transform = '-66.666666%';
      } else if (globals.windowScrollTop >= globals.offsetTop) {
        transform = '-33.333333%';
        if ($postNavShare.length) {
          $postNavShare.addClass('active');
        }
      } else {
        transform = '0';
        if ($postNavShare.length) {
          $postNavShare.removeClass('active');
        }
      }

      $postNav.css('transform', `translateY(${transform})`);
    });
  }
};
export default postHeader;



// WEBPACK FOOTER //
// ./src/scripts/modules/post-header.js